module.exports = __webpack_public_path__ + "static/media/onepostLogo.276f4c0a.svg";